// components/ClearCache.tsx
'use client'

import React, { useMemo, useState } from 'react'
import { Button, useListQuery, useSelection } from '@payloadcms/ui'
import { clearAllCDNCache, clearCDNCache } from '@/website/utils/clearCDNCache'
import './ClearCache.scss'

export const ClearCache = () => {
  const [allClearing, setAllClearing] = useState(false)
  const [clearing, setClearing] = useState(false)
  const [message, setMessage] = useState('')
  const { refineListData, data } = useListQuery()
  const { selected } = useSelection()

  const isCheckBoxSelected = useMemo(() => {
    return selected.values().some(value => value)
  }, [selected])

  const clickClearCache = async () => {
    setClearing(true)
    setMessage('')

    try {
      const tags: (string|number)[] = []
      selected.forEach((value, key) => {
        if (value) {
          tags.push(key)
        }
      })
      const result = await clearCDNCache(tags);
      if (result.status === 'success') {
        setMessage(`Successfully cleared cache`)
        await refineListData({
          limit: '0'
        })
      } else {
        setMessage(`Error occured while clearing cache`)
      }
    } catch (error) {
      setMessage(`Error: ${error instanceof Error ? error.message : 'Unknown error'}`)
    } finally {
      setClearing(false)
    }
  }

  const clickClearCacheAll = async () => {
    setAllClearing(true)
    setMessage('')

    const clearAll = confirm('Are you sure you want to clear All cache? This will clear the whole site cache on Cloudflare and not just the listed tags.')

    try {
      if (!clearAll) {
        setAllClearing(false)
        return;
      }
      const result = await clearAllCDNCache();
      if (result.status === 'success') {
        setMessage(`Successfully cleared All cache`)
      } else {
          setMessage(`Error occured while clearing All cache`)
      }
    } catch (error) {
      setMessage(`Error: ${error instanceof Error ? error.message : 'Unknown error'}`)
    } finally {
      setAllClearing(false)
    }
  }

  return (
    <div className={'gutter--left gutter--right'}>
      <div className='cached-urls-actions'>
        <Button
          onClick={clickClearCache}
          disabled={clearing || allClearing || data.totalDocs === 0}
          buttonStyle="primary"
          className='cached-urls-actions__clear-cache'
        >
          {clearing ? 'Clearing Cache...' : isCheckBoxSelected ? 'Clear Selected Cache' : 'Clear All Listed Cache'}
        </Button>
        <Button
          onClick={clickClearCacheAll}
          disabled={allClearing || clearing}
          buttonStyle="primary"
        >
          {allClearing ? 'Clearing Global Cache...' : 'Clear Global Cache'}
        </Button>
      </div>
      {message && (
        <div
          className='cached-urls-actions__message'
          style={{
            backgroundColor: message.includes('Error') ? '#fee' : '#efe',
            color: message.includes('Error') ? '#c00' : '#060'
          }}
        >
          {message}
        </div>
      )}
    </div>
  )
}
